import { Action, initialState, State } from "store/store";

export const updateRecoloredChameleonImages = (
  state: State = initialState,
  { data }: Action
): State => {
  const nextState = {
    ...state,
    theme: {
      ...(state as any).theme,
      recoloredChameleonImages: {
        ...(state as any).theme.recoloredChameleonImages,
        ...data,
      },
    },
  };

  return nextState;
};
